import { CURRENCY_CONFIG, SET_DASHBOARD_DATA, SET_DASHBOARD_DATA_DEFAULT, SET_FIAT_SERVICE } from "../actions/actionTypes";

const initialState = {
  balance: 0,
  count: 0,
  orders: [],
  fetched: false,
  fiatService: {
    enableFiat: false,
    serviceName: null,
    services: [],
    isConflict: false,
    travelRule: false,
    currencies: [],
    cryptoProvider: null,
  },
  currencies: [],
}
function DashboardReducers(state = initialState, action) {
  switch (action.type) {
    case SET_DASHBOARD_DATA:
      return {
        ...state,
        ...action.payload,
        fetched: true
      };
    case SET_DASHBOARD_DATA_DEFAULT:
      return {
        ...initialState
      }
    case SET_FIAT_SERVICE:
      return {
        ...state,
        fiatService: {
          enableFiat: action.payload.enableFiat,
          serviceName: action.payload.serviceName,
          services: action.payload.services,
          isConflict: action?.payload?.isConflict || false,
          travelRule: action?.payload?.travelRule || false,
          currencies: action?.payload?.currencies || [],
          cryptoProvider: action?.payload?.cryptoProvider || null,
          showSidebar: action?.payload?.showSidebar
        }
      }
    case CURRENCY_CONFIG:
      return {
        ...state,
        currencies: action.payload,
      }
    default:
      return state;
  }
}
export default DashboardReducers;
